module.exports = __webpack_public_path__ + "03_short_yellow.82a86936.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_short_yellow.png
// module id = FevU
// module chunks = 0